var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"participationRate",attrs:{"id":_vm.Id}},[_vm._v(" "+_vm._s(_vm.type.fieldName)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }